import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { officeFactsItem as saveOfficeFacts } from 'utils/urls';

import { OfficeFactsInput } from 'types/accounts';
import { ErrorModal } from 'types/modalTypes';

export async function postOfficeFacts(
  params: OfficeFactsInput,
): Promise<TResult> {
  const response = await fetch(saveOfficeFacts(params.AccountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

export type TResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: OfficeFactsInput | null;
} & ErrorModal;

type TVariables = OfficeFactsInput;

type TError = ErrorModal;

type TSnapshot = unknown;

async function wait(millis: number) {
  return new Promise(resolve => {
    setTimeout(resolve, millis);
  });
}

function useSaveOfficeFacts(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: OfficeFactsInput) => {
    const newOfficeFacts = await postOfficeFacts(params);
    if (newOfficeFacts.Data) {
      queryClient.invalidateQueries(['get_officeFacts', params.AccountId], {
        refetchActive: true,
        refetchInactive: true,
      });
      await wait(2000);
    } else if (newOfficeFacts.Errors) throw newOfficeFacts;
    return newOfficeFacts;
  });
}

export { useSaveOfficeFacts };
